import React, {useEffect, useState} from "react";
import Container from "@material-ui/core/Container";
import {Card, Grid, Box, Hidden, Typography, Button} from "@material-ui/core";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../redux/store";
import {ReactComponent as LogoSVG} from "../../Images/logo.svg";
import {getPetByID} from "../../redux/pets/pets.actions";
import {makeStyles, Theme} from "@material-ui/core/styles";
import {useHistory} from "react-router-dom";
import {setPetType} from "../../utils/petInfo";
import {createPetTypeIconLookup} from "../../utils/petTypeIcons";
import {statesWithoutPrescription} from "../../Constants/locations";
import Image from "material-ui-image";

const useStyle = makeStyles((theme: Theme) => ({
    wrapper: {
        padding: 70,
        [theme.breakpoints.down("xs")]: {
            padding: 20
        }
    },
    button: {
        padding: "1em 2em"
    },
    caption: {
        maxWidth: "90%",
        fontWeight: 400,
        marginBottom: 10
    }
}));

const NoRxDisclaimer = () => {
    const classes = useStyle();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const branding = useSelector((state: RootState) => state?.branding);
    const petId = useSelector((state: RootState) => state?.scheduleAppointment.selectedPetId);
    const location = useSelector((state: RootState) => state?.common.location);
    let isTelehealthOnly =  !location ? true : statesWithoutPrescription.find(state => state.value === location);
    const pet = useSelector((state: RootState) => state?.pets.selectedPet);
    const [linkToImage, setLinkToImage] = useState("");
    const handleImageLoadError = () => {
        setLinkToImage("");
    };

    useEffect(() => {
        dispatch(getPetByID(petId))
            .then(pet => setLinkToImage(pet.imageUrl))
            .catch(err => console.log(err));
    }, []);

    return (
        <Container maxWidth="md">
            <Box marginTop="115px" marginBottom="75px">
                <Grid container justify="center">
                    <Grid item md={9} xs={12} container justify="center">
                        <Card variant="outlined" className={classes.wrapper}>
                            <Box display="flex" justifyContent="center" marginBottom="20px">
                                {!isWhiteLabel ? (
                                    linkToImage ?
                                        <img
                                            src={linkToImage}
                                            alt="pet image" 
                                            onError={handleImageLoadError}
                                            width="100"
                                            height="100"
                                            style={{objectFit: "cover"}}
                                        />
                                        :
                                        createPetTypeIconLookup()[setPetType(pet.type)] ||
                                        <Box display="flex" justifyContent="center"
                                            alignItems="center" width="100px"
                                            height="100px">
                                            <LogoSVG/>
                                        </Box>
                                )
                                    :
                                    <Box display="flex"
                                        justifyContent="center"
                                        alignItems="center" width="100px"
                                        height="100px">
                                        <Image
                                            alt="pet image" 
                                            imageStyle={{objectFit: "cover"}}
                                            src={linkToImage}
                                            errorIcon={<img alt="error icon" src={branding.logo} width="100%"/>}
                                            style={{width: "100%"}}/>
                                    </Box>
                                }
                            </Box>
                            <Box display="flex" flexDirection="column" alignItems="center" marginBottom="20px">
                                {(!isTelehealthOnly || isWhiteLabel)?
                                    <Typography variant="h4" className={classes.caption} align="center">
                                        Since you are booking an advice appointment, this appointment cannot result in a prescription.
                                    </Typography> :
                                    <Typography variant="h4" className={classes.caption} align="center">
                                        Due to your state laws, this appointment cannot result in a prescription.
                                        However, the vet may provide over the counter suggestions, at-home remedies, and help you better understand your pet’s status of health.
                                    </Typography>
                                }
                            </Box>
                            <Box display="flex" justifyContent="center">
                                <Button
                                    type="button"
                                    variant="contained"
                                    color="secondary"
                                    className={classes.button}
                                    onClick={() => history.push("/consent")}
                                >
									Ok
                                </Button>
                            </Box>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};

export default NoRxDisclaimer;
